import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2, UserPlus, Clock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AuthShell, formatApiErrorDetail } from "../components/AuthShell";

const API = process.env.REACT_APP_BACKEND_URL;
const F = ({ id, label, children }) => (<div className="space-y-1.5"><Label htmlFor={id} className="text-slate-700">{label}</Label>{children}</div>);

export default function RegisterPage() {
  const [f, setF] = useState({ username: "", full_name: "", email: "", position: "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return setError("Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.");
    if (f.password !== f.confirm) return setError("Οι κωδικοί δεν ταιριάζουν.");
    setLoading(true); setError("");
    try {
      const r = await axios.post(`${API}/api/auth/register`, { username: f.username.trim(), full_name: f.full_name.trim(), email: f.email.trim(), position: f.position.trim(), password: f.password });
      setDone(r.data.message);
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <Link to="/login" className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900 mb-6" data-testid="back-to-login-link"><ArrowLeft className="w-3.5 h-3.5" /> Επιστροφή στη σύνδεση</Link>
      <h2 className="text-base md:text-lg font-semibold text-slate-900">Εγγραφή στο σύστημα</h2>
      <p className="text-sm text-slate-500 mt-1 mb-6">Η αίτηση εξετάζεται από τον Διαχειριστή. Θα μπορείτε να συνδεθείτε μόλις εγκριθεί.</p>
      {done ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-5 flex gap-3" data-testid="register-success">
          <Clock className="w-6 h-6 text-amber-600 shrink-0" />
          <div className="text-sm text-amber-900"><p className="font-semibold">Η αίτηση καταχωρήθηκε — σε αναμονή έγκρισης</p><p className="mt-1">{done}</p></div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <F id="username" label="Όνομα χρήστη"><Input id="username" value={f.username} onChange={set("username")} required className="h-11" autoComplete="username" data-testid="register-username" /></F>
            <F id="full_name" label="Ονοματεπώνυμο"><Input id="full_name" value={f.full_name} onChange={set("full_name")} required className="h-11" data-testid="register-fullname" /></F>
          </div>
          <F id="email" label="Email"><Input id="email" type="email" value={f.email} onChange={set("email")} required className="h-11" autoComplete="email" data-testid="register-email" /></F>
          <F id="position" label="Θέση / Υπηρεσία (προαιρετικό)"><Input id="position" value={f.position} onChange={set("position")} className="h-11" placeholder="π.χ. Γραμματέας Τμήματος Προσδιορισμού" data-testid="register-position" /></F>
          <div className="grid sm:grid-cols-2 gap-4">
            <F id="password" label="Κωδικός (≥ 8 χαρακτήρες)"><Input id="password" type="password" value={f.password} onChange={set("password")} required minLength={8} className="h-11" autoComplete="new-password" data-testid="register-password" /></F>
            <F id="confirm" label="Επιβεβαίωση κωδικού"><Input id="confirm" type="password" value={f.confirm} onChange={set("confirm")} required minLength={8} className="h-11" autoComplete="new-password" data-testid="register-confirm" /></F>
          </div>
          {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-11 bg-slate-900 hover:bg-slate-800 rounded-xl" data-testid="register-submit">
            {loading ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <UserPlus className="w-5 h-5 mr-2" />} Υποβολή αίτησης εγγραφής
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
